import type { SeriesOption } from 'echarts';

import type { CompleteOptionSection, OptionSection } from '../types/OptionSection.types';

type SeriesAxisIndexes = {
  xAxisIndex?: unknown;
  yAxisIndex?: unknown;
};

const EMPTY_COMPOSITION: CompleteOptionSection = { xAxis: [], yAxis: [], series: [] };

function shiftIndex(index: unknown, offset: number): number {
  return (typeof index === 'number' ? index : 0) + offset;
}

function shiftSeries(series: SeriesOption, xOffset: number | undefined, yOffset: number | undefined): SeriesOption {
  const { xAxisIndex, yAxisIndex } = series as SeriesAxisIndexes;

  return {
    ...series,
    ...(xOffset !== undefined && { xAxisIndex: shiftIndex(xAxisIndex, xOffset) }),
    ...(yOffset !== undefined && { yAxisIndex: shiftIndex(yAxisIndex, yOffset) }),
  };
}

export function composeOptionSections(sections: Array<OptionSection | undefined>): CompleteOptionSection {
  return sections.reduce<CompleteOptionSection>((composed, section) => {
    if (!section) {
      return composed;
    }

    const { xAxis = [], yAxis = [], series = [] } = section;
    const xOffset = xAxis.length > 0 ? composed.xAxis.length : undefined;
    const yOffset = yAxis.length > 0 ? composed.yAxis.length : undefined;

    return {
      xAxis: [...composed.xAxis, ...xAxis],
      yAxis: [...composed.yAxis, ...yAxis],
      series: [...composed.series, ...series.map((item) => shiftSeries(item, xOffset, yOffset))],
    };
  }, EMPTY_COMPOSITION);
}
